import React from "react";
import YouTube from "react-youtube";
import { useAppTranslation } from "../../i18n/useAppTranslation";

type Props = {};

const HowToPlay = (props: Props) => {
  const { t } = useAppTranslation("learn");

  const data = [
    {
      index: 0,
      titleKey: "learn:howToPlay.videos.gamePlayOverview",
      videoId: "KXGCR8731sU",
    },
    {
      index: 1,
      titleKey: "learn:howToPlay.videos.walletCleg",
      videoIds: [
        {
          titleKey: "learn:howToPlay.platform.forPc",
          id: "L_tQBctzsCU",
        },
        {
          titleKey: "learn:howToPlay.platform.forMobile",
          id: "xgb-vumhf3E",
        },
      ],
    },
    {
      index: 2,
      titleKey: "learn:howToPlay.videos.referralProgram",
      videoId: "QZXe60Hb9UM",
    },
    {
      index: 3,
      titleKey: "learn:howToPlay.videos.barracksAndDungeons",
      videoId: "RCnLJ9Dqdc0",
    },
    {
      index: 4,
      titleKey: "learn:howToPlay.videos.treasureIsland",
      videoId: "61d0Z94jYfo",
    },
    {
      index: 5,
      titleKey: "learn:howToPlay.videos.tokenomics",
      videoId: "kpS4dyrw3wU",
    },
    {
      index: 6,
      titleKey: "learn:howToPlay.videos.guilds",
      videoId: "jfrbQnfEcOQ",
    },
    {
      index: 7,
      titleKey: "learn:howToPlay.videos.arenaBattles",
      videoId: "U13anbsDa5g",
    },
  ];

  return (
    <div className="py-4 text-white">
      <div className=" text-center">{t("learn:howToPlay.intro")}</div>
      <div className="row justify-content-center">
        {data.map(({ index, titleKey, videoId, videoIds }) => (
          <div
            key={index}
            className={
              (index > 1 ? " col-lg-6 col-12" : "col-12") +
              " mt-5 d-flex align-items-center flex-column justify-content-center"
            }
          >
            <div className="fs-lg mb-3 ">{`${index + 1}. ${t(titleKey)}`}</div>
            {videoIds ? (
              <div className="w-100 justify-content-between d-flex align-items-center">
                {videoIds?.map((vid) => (
                  <div key={vid.id} className="text-center">
                    <YouTube
                      style={{ height: 300, width: 500 }}
                      iframeClassName="w-100 h-100"
                      videoId={vid.id}
                    />
                    <div className="mt-3">{t(vid.titleKey)}</div>
                  </div>
                ))}
              </div>
            ) : (
              <YouTube
                style={{ height: 300, width: 500 }}
                iframeClassName="w-100 h-100"
                videoId={videoId}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowToPlay;
